const APP_HOSTS = new Set(['app.zeedcom.com', 'dev.zeedcom.com']);
const APP_ORIGIN = 'https://app.zeedcom.com';
const NATIVE_ANDROID_UA = /ZeedcomApp\//;

export function isAppHost(): boolean {
  if (typeof window === 'undefined') return false;
  return APP_HOSTS.has(window.location.hostname.toLowerCase());
}

export function isNativeAndroidApp(): boolean {
  if (typeof navigator !== 'undefined' && NATIVE_ANDROID_UA.test(navigator.userAgent)) {
    return true;
  }
  if (typeof document !== 'undefined' && document.referrer.startsWith('android-app://')) {
    return true;
  }
  return false;
}

/** Play wrapper: WebView (current) or legacy TWA. */
export function isTwa(): boolean {
  return isNativeAndroidApp();
}

export function isInstalledApp(): boolean {
  if (typeof window === 'undefined') return false;

  const standalone =
    window.matchMedia('(display-mode: standalone)').matches
    || window.matchMedia('(display-mode: fullscreen)').matches;

  const iosStandalone = (window.navigator as Navigator & { standalone?: boolean }).standalone === true;

  return standalone || iosStandalone || isNativeAndroidApp();
}

export function isAppShell(): boolean {
  return isAppHost() || isInstalledApp();
}

/** Login / register / ouvrir l’app depuis la vitrine → app. En local ou déjà sur app : chemin relatif. */
export function appUrl(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`;
  if (typeof window === 'undefined') return `${APP_ORIGIN}${p}`;
  const host = window.location.hostname.toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1' || isAppHost()) return p;
  return `${APP_ORIGIN}${p}`;
}
